import React, { useEffect, useState } from "react";
import axios from "axios";
import ViewTicket from "./ViewTicket";
import { baseurl } from "../../constant";

const CreateTicket = () => {
  const [err, seterr] = useState();
  const [data, setdata] = useState();
  const [subject, setsubject] = useState();
  const [message, setmessage] = useState();
  const [related_to, setrelated_to] = useState();
  const [image, setimage] = useState();
  const [statusmessage, setstatusmessage] = useState();
  const [status, setstatus] = useState();
  const [active, setactive] = useState(1);
  const changecomponent = (change) => {
    setactive(change);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const base64 = reader.result;

        const cleanBase64 = base64.split(",")[1];
        setimage(cleanBase64);
      };
    }
  };

  const token = localStorage.getItem("authToken");
  const getdata = async () => {
    try {
      const result = await axios.post(baseurl + "getTicketRelatedList", {
        token: token,
      });

      setdata(result.data.data);
    } catch (err) {
      seterr(err);
    }
  };

  const getdata1 = async () => {
    try {
      const result = await axios.post(baseurl + "ticketPostAuth", {
        token: token,
        subject: subject,
        related_to: related_to,
        message: message,
        image: image,
      });

      setstatusmessage(result.data.message);
      setstatus(result.data.status);
      setdata(result.data.data);
      setmessage("");
      setsubject("");
      setimage("");
      setrelated_to("");
    } catch (err) {
      seterr(err);
    }
  };

  useEffect(() => {
    getdata();
  }, []);

  return (
    <>
      {active == 1 && (
        <div>
          <div className="card shadow ">
            <div className="card-header py-3">
              <div className="row">
                <div className="col-sm-6">
                  <h4>
                    <b>Create Ticket</b>
                    {status == 1 && (
                      <p style={{ backgroundColor: "#d2f4e8", color: "green" }}>
                        {statusmessage}
                      </p>
                    )}
                    {status == 0 && (
                      <p style={{ backgroundColor: "red" }}>{statusmessage}</p>
                    )}
                  </h4>
                </div>

                <div className="col-sm-6  text-right">
                  <button
                    onclick="window.history.back()"
                    className="btn btn-primary"
                  >
                    <i
                      className="fa fa-arrow-left"
                      onClick={() => changecomponent(2)}
                    >
                      {" "}
                      Back
                    </i>
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body">
              <form
                action="https://www.payol.in/portal/ticket/saveTicketAuth"
                id="admin_profile"
                enctype="multipart/form-data"
                method="post"
                accept-charset="utf-8"
              />
              <input type="hidden" name="method" value="post" />
              <input type="hidden" value="https://www.payol.in/" id="siteUrl" />
              <div className="row">
                <div className="col-sm-8">
                  <div className="form-group">
                    <label>
                      <b>Subject*</b>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      placeholder="Subject"
                      value={subject}
                      onChange={(e) => setsubject(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-sm-2">
                  <div className="form-group">
                    <label>
                      <b>Related To</b>
                    </label>
                    <select
                      className=" form-control"
                      name="related_to"
                      id="related_to"
                      data-live-search="true"
                      value={related_to}
                      onChange={(e) => setrelated_to(e.target.value)}
                    >
                      {data &&
                        data.map((item) => (
                          <option value={item.id}>{item.title}</option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-sm-8">
                  <div className="form-group">
                    <label>
                      <b>Message</b>
                    </label>
                    <textarea
                      className="form-control"
                      rows="8"
                      name="message"
                      id="message"
                      value={message}
                      onChange={(e) => setmessage(e.target.value)}
                    ></textarea>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="form-group">
                    <label>
                      <b>Attachment</b>
                    </label>
                    <input
                      type="file"
                      name="attachment"
                      onChange={handleFileChange}
                    />
                    <p>
                      Allowed File Extenstions: .jpg, .png, .gif <br /> Max Size
                      Should be : 2MB
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card shadow">
            <div className="card-header py-3 text-right">
              <button
                type="submit"
                className="btn btn-success"
                onClick={getdata1}
              >
                Submit
              </button>
              <button
                onclick="window.history.back()"
                type="button"
                className="btn btn-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {active == 2 && <ViewTicket />}
    </>
  );
};

export default CreateTicket;
